import { render, staticRenderFns } from "./MilestoneGroupList.vue?vue&type=template&id=33060289&"
import script from "./MilestoneGroupList.vue?vue&type=script&lang=js&"
export * from "./MilestoneGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports